import { NoticeDetail } from './notice-detail'

export interface NoticeInterface {
  /**
   * 总数据
   */
  count?: number
  readedCount?: number
  unreadedCount?: number
  details?: NoticeDetail[]
}

export class Notice implements NoticeInterface {
  /**
   * 总数据
   */
  count?: number
  readedCount?: number
  unreadedCount?: number
  details?: NoticeDetail[]

  constructor(props: NoticeInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      count: _count,
      readedCount: _readedCount,
      unreadedCount: _unreadedCount,
      details: _details,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.count = _count
    this.readedCount = _readedCount
    this.unreadedCount = _unreadedCount
    this.details = _details
      ? _details.map((i) => new NoticeDetail(i))
      : _details
  }
}
